module.exports = __webpack_public_path__ + "static/media/Cleyson_Dellcorso_Premium_Site.d7461450.jpg";